import {
    FETCH_APPLICATION_LIST,
    FETCH_APPLICATION_LIST_ERROR,
    FETCH_APPLICATION_LIST_SUCCESS,
    SET_APPLICATIONS_SEARCH_TERM,
    UNMOUNT_APPLICATION_DETAIL,

    // Create new Application
    CREATE_NEW_APPLICATION,
    CREATE_NEW_APPLICATION_ERROR,

    // Account Notifications
    FETCH_NOTIFICATION_LIST,
    FETCH_NOTIFICATION_LIST_SUCCESS,
    FETCH_NOTIFICATION_LIST_ERROR,

    // Account Notifications
    UPDATE_NOTIFICATION,
    UPDATE_NOTIFICATION_SUCCESS,
    UPDATE_NOTIFICATION_ERROR,
} from './constants';

export const fetchApplicationList = () => ({
    type: FETCH_APPLICATION_LIST,
});

export const fetchApplicationListSuccess = (data) => ({
    type: FETCH_APPLICATION_LIST_SUCCESS,
    payload: { data },
});

export const fetchApplicationListError = (data) => ({
    type: FETCH_APPLICATION_LIST_ERROR,
    payload: { data },
});

export const setApplicationsSearchTerm = (searchTerm) => ({
    type: SET_APPLICATIONS_SEARCH_TERM,
    payload: { searchTerm },
});

export const createNewApplication = (payload, message) => ({
    type: CREATE_NEW_APPLICATION,
    payload,
    message,
});

export const crateNewApplicationError = () => ({
    type: CREATE_NEW_APPLICATION_ERROR,
});

export const unmountApplicationDetail = () => ({
    type: UNMOUNT_APPLICATION_DETAIL,
});

// Account Notifications
export const fetchNotificationList = (userId) => ({
    type: FETCH_NOTIFICATION_LIST,
    payload: userId,
});

export const fetchNotificationListSuccess = (payload) => ({
    type: FETCH_NOTIFICATION_LIST_SUCCESS,
    payload,
});

export const fetchNotificationListError = () => ({
    type: FETCH_NOTIFICATION_LIST_ERROR,
});

// Update Notification
export const updateNotification = (userId, notificationId, data) => ({
    type: UPDATE_NOTIFICATION,
    payload: { userId, notificationId, data },
});

export const updateNotificationSuccess = (notificationId, data) => ({
    type: UPDATE_NOTIFICATION_SUCCESS,
    payload: { notificationId, data },
});

export const updateNotificationError = () => ({
    type: UPDATE_NOTIFICATION_ERROR,
});
